<template>
  <div :class="{ 'tw-p-6': cart, 'tw-mb-2': !isLoading }">
    <p
      class="tw-text-xs tw-font-medium tw-uppercase tw-tracking-widest tw-mb-6"
    >
      {{ heading }}
    </p>
    <div
      class="tw-border-2 mod-global--border-radius tw-flex tw-justify-between tw-items-start tw-px-5 tw-py-3 tw-mb-4 tw-bg-dark-3 tw-border-dark-1"
    >
      <div>
        <p class="mod-h6 tw-mb-2">
          {{ selectedPack.amount.toLocaleString() }}
          {{ tokenName }}
        </p>
        <p class="tw-opacity-70 tw-leading-none">{{ gameName }}</p>
      </div>
      <p class="mod-h6">
        {{ humanPriceFormat(convertToDecimal(selectedPack.price)) }}
      </p>
    </div>
    <div>
      <div class="tw-flex tw-w-full tw-justify-between">
        <span class="tw-opacity-70">{{ $t('marketplace.subtotal') }}</span>
        <span>{{
          humanPriceFormat(convertToDecimal(selectedPack.price))
        }}</span>
      </div>
      <div class="tw-flex tw-w-full tw-justify-between">
        <span class="tw-opacity-70">{{ $t('marketplace.taxes') }}</span>
        <span>{{
          cart
            ? $t('marketplace.calculated_at_checkout')
            : humanPriceFormat(convertToDecimal(tax))
        }}</span>
      </div>
      <base-divider class="tw-my-2" />
      <div class="tw-flex tw-w-full tw-justify-between">
        <span class="tw-font-bold">{{ $t('marketplace.total_due') }}</span>
        <span>{{
          cart
            ? $t('marketplace.calculated_at_checkout')
            : humanPriceFormat(convertToDecimal(selectedPack.price + tax))
        }}</span>
      </div>
    </div>
    <base-loading-icon
      v-if="isLoading"
      show
      class="tw-relative tw-max-h-24 tw-overflow-hidden"
    />
  </div>
</template>

<script>
import {
  humanPriceFormat,
  convertToDecimal,
} from '@helpers/monetizationUtils.js'

export default {
  props: {
    heading: {
      type: String,
      required: true,
    },
    selectedPack: {
      type: Object,
      required: true,
    },
    gameName: {
      type: String,
      required: true,
    },
    tokenName: {
      type: String,
      required: true,
    },
    cart: {
      type: Boolean,
      default: false,
    },
    tax: {
      type: Number,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      humanPriceFormat,
      convertToDecimal,
    }
  },
}
</script>
